import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { NeedGenrationComponent } from '../stape-component/need-genration/need-genration.component';
import { AIPComponent } from '../stape-component/aip/aip.component';
import { ConstituteCommitteeComponent } from '../stape-component/constitute-committee/constitute-committee.component';
import { FeasibiltyStudyComponent } from '../feasibilty-study/feasibilty-study.component';
import { MakeIBenchmarkComponent } from '../stape-component/make-i-benchmark/make-i-benchmark.component';
import { CommercialEvaluationComponent } from '../stape-component/financial-evaluation/commercial-evaluation.component';
import { FirmResponseSubmissionComponent } from '../firm-response-submission/firm-response-submission.component';
import { RFiComponent } from '../stape-component/rfi/rfi.component';
import { RfpDetailsComponent } from '../stape-component/rfp-details/rfp-details.component';
import { DraftSocComponent } from '../stape-component/draft-soc/draft-soc.component';
import { VcnsApprovalComponent } from '../stape-component/vcns-approval/vcns-approval.component';
import { ReceiptMomComponent } from '../stape-component/receipt-mom/receipt-mom.component';
import { InitiationOfProposalComponent } from '../stape-component/initiation-of-proposal/initiation-of-proposal.component';
import { VendorComponent } from '../stape-component/vendor/vendor.component';
import { PsqrComponent } from '../psqr/psqr.component';
import { AonSocComponent } from '../aon-soc/aon-soc.component';
import { AONComponent } from '../stape-component/aon/aon.component';
import { PddComponent } from '../pdd/pdd.component';
import { EOIComponent } from '../stape-component/eoi/eoi.component';
import { PreRfpMeetingComponent } from '../stape-component/pre-rfp-meeting/pre-rfp-meeting.component';
import { MakeIBidComponent } from '../make-i-bid/make-i-bid.component';
import { ShortlistingVendorsComponent } from '../stape-component/shortlisting-vendors/shortlisting-vendors.component';
import { IdexCommercialRfpComponent } from '../idex-commercial-rfp/idex-commercial-rfp.component';
import { UploadDprComponent } from '../upload-dpr/upload-dpr.component';
import { TechnicalEveluationComponent } from '../stape-component/technical-eveluation/technical-eveluation.component';
import { MakeITechnicalNegotiationsComponent } from '../stape-component/make-i-technical-negotiations/make-i-technical-negotiations.component';
import { CommercialNegocatitionComponent } from '../stape-component/commercial-negocatition/commercial-negocatition.component';
import { FinalOfferComponent } from '../stape-component/final-offer/final-offer.component';
import { SanctionOrderComponent } from '../stape-component/sanction-order/sanction-order.component';
import { IdexPrototypeComponent } from '../idex-prototype/idex-prototype.component';
import { IdexUtrrComponent } from '../idex-utrr/idex-utrr.component';
import { SsctComponent } from '../ssct/ssct.component';
import { StaffEvaluationComponent } from '../staff-evaluation/staff-evaluation.component';
import { BulkProductionComponent } from '../bulk-production/bulk-production.component';
import { TransHeaderSteperComponent } from '../../components/trans-header-steper/trans-header-steper.component';
import { PreBidComponent } from '../stape-component/pre-bid/pre-bid.component';
import { EvaluationOfEoiComponent } from '../evaluation-of-eoi/evaluation-of-eoi.component';
import { TechnicalNegotiationsComponent } from '../stape-component/technical-negotiations/technical-negotiations.component';
import { PsqrToSqrComponent } from '../psqr-to-sqr/psqr-to-sqr.component';
import { UploadDrawingsComponent } from '../upload-drawings/upload-drawings.component';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-make-i-transaction',
  standalone: false,
  templateUrl: './make-i-transaction.component.html',
  styleUrl: './make-i-transaction.component.scss'
})
export class MakeITransactionComponent implements OnInit, OnDestroy {
  @ViewChild(NeedGenrationComponent) needGen?: NeedGenrationComponent;
  @ViewChild(AIPComponent) aip?: AIPComponent;
  @ViewChild(ConstituteCommitteeComponent) constituteCommitteeComponent?: ConstituteCommitteeComponent;
  @ViewChild(FeasibiltyStudyComponent) feasibiltyStudyComponent?: FeasibiltyStudyComponent;
  @ViewChild(MakeIBenchmarkComponent) makeIBenchmark?: MakeIBenchmarkComponent;
  @ViewChild(CommercialEvaluationComponent) commercialEvaluation?: CommercialEvaluationComponent;
  @ViewChild(FirmResponseSubmissionComponent) firmResponseSubmissionComponent?: FirmResponseSubmissionComponent;
  @ViewChild(RFiComponent) rfiComponent?: RFiComponent;
  @ViewChild(RfpDetailsComponent) rfpDetailsComponent?: RfpDetailsComponent;
  @ViewChild(DraftSocComponent) draftSocComponent?: DraftSocComponent;
  @ViewChild(VcnsApprovalComponent) vcnsApprovalComponent?: VcnsApprovalComponent;
  @ViewChild(ReceiptMomComponent) receiptMomComponent?: ReceiptMomComponent;
  @ViewChild(InitiationOfProposalComponent) initiationOfProposalComponent?: InitiationOfProposalComponent;
  @ViewChild(VendorComponent) vendorComponent?: VendorComponent;
  @ViewChild(PsqrComponent) psqrComponent?: PsqrComponent;
  @ViewChild(AonSocComponent) aonSocComponent?: AonSocComponent;
  @ViewChild(AONComponent) aonComponent?: AONComponent;
  @ViewChild(PddComponent) pddComponent?: PddComponent;
  @ViewChild(EOIComponent) eoiComponent?: EOIComponent;
  @ViewChild(PreRfpMeetingComponent) preRfpMeetingComponent?: PreRfpMeetingComponent;
  @ViewChild(MakeIBidComponent) makeIBidComponent?: MakeIBidComponent;
  @ViewChild(ShortlistingVendorsComponent) shortlistingVendorsComponent?: ShortlistingVendorsComponent;
  @ViewChild(IdexCommercialRfpComponent) idexCommercialRfpComponent?: IdexCommercialRfpComponent;
  @ViewChild(UploadDprComponent) uploadDprComponent?: UploadDprComponent;
  @ViewChild(TechnicalEveluationComponent) technicalEveluationComponent?: TechnicalEveluationComponent;
  @ViewChild(MakeITechnicalNegotiationsComponent) makeITechnicalNegotiationsComponent?: MakeITechnicalNegotiationsComponent;
  @ViewChild(CommercialNegocatitionComponent) commercialNegocatitionComponent?: CommercialNegocatitionComponent;
  @ViewChild(FinalOfferComponent) finalOfferComponent?: FinalOfferComponent;
  @ViewChild(SanctionOrderComponent) sanctionOrderComponent?: SanctionOrderComponent;
  @ViewChild(IdexPrototypeComponent) idexPrototypeComponent?: IdexPrototypeComponent;
  @ViewChild(IdexUtrrComponent) idexUtrrComponent?: IdexUtrrComponent;
  @ViewChild(SsctComponent) ssctComponent?: SsctComponent;
  @ViewChild(StaffEvaluationComponent) staffEvaluationComponent?: StaffEvaluationComponent;
  @ViewChild(BulkProductionComponent) bulkProductionComponent?: BulkProductionComponent;
  @ViewChild(TransHeaderSteperComponent) transHeaderSteperComponent?: TransHeaderSteperComponent;
  @ViewChild(PreBidComponent) preBidComponent?: PreBidComponent;
  @ViewChild(EvaluationOfEoiComponent) evaluationOfEOI?: EvaluationOfEoiComponent;
  @ViewChild(TechnicalNegotiationsComponent) technicalNegotiation?: TechnicalNegotiationsComponent;
  @ViewChild(UploadDrawingsComponent) uploadDrawingDocument?: UploadDrawingsComponent;
  @ViewChild( PsqrToSqrComponent ) psqrToSqr?: PsqrToSqrComponent;
  @ViewChild('dt') documentTable!: Table;

  role_id=sessionStorage.getItem('user_role_id');

  baseUrl = environment.APIUrl;
  masterData: any[] = [];
  pdfdata: any;
  DocName = '';
  displayDialog = false;
  proposalId!: number | string;
  proposalName = '';
  schemeId!: number | string;
  phaseId!: number | string;
  step_details: any;
  userGuide: string = 'process';
  reportList: any[] = [];
  documentList: any[] = [];
  searchText = '';
  tabList: any[] = [];
  confirmChecked = false;
  isEditable: boolean = false;
  private subscriptions = new Subscription();

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    const paramsSub = this.route.queryParams.subscribe(params => {
      this.proposalId = params['id'];
      this.proposalName = params['name'] ?? '';
      this.phaseId = params['phase'];
      this.schemeId = params['scheme'];
      
    });
    this.subscriptions.add(paramsSub);
    this.fetchMasterData();
    this.fetchTabs();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getReportList(): void {
    if (!this.step_details?.id || !this.proposalId) return;
    this.reportList = [];
    const sub = this.api
      .getAPI(`/revenue/need/version-control/?proposal_step=${this.step_details.id}&proposal_step__proposal=${this.proposalId}`)
      .subscribe({
        next: (res: any) => (this.reportList = res || []),
        error: () => this.messageService.add({
          severity: 'error', summary: 'Error', detail: 'Unable to fetch report versions.'
        })
      });
    this.subscriptions.add(sub);
  }

  // getDocumentList(): void {
  //   if (!this.proposalId || !this.schemeId) return;
  //   this.documentList = [];
  //   const sub = this.api
  //     .getAPI(`/make1/dms/documents/${this.schemeId}/${this.proposalId}/`)
  //     .subscribe({
  //       next: (res: any) => (this.documentList = this.prepareDocumentList(res) || []),
  //       error: () => this.messageService.add({
  //         severity: 'error', summary: 'Error', detail: 'Unable to fetch documents.'
  //       })
  //     });
  //   this.subscriptions.add(sub);
  // }
   getDocumentList() {
    this.documentList = []
    const sub = this.api.getAPI(`/transaction/dms/files/?proposal_step__proposal=${this.proposalId}`).subscribe((res: any) => {
      this.documentList = res.data
    });
    this.subscriptions.add(sub);
  }

  prepareDocumentList(data: any): any[] {
    const docs: any[] = [];
    if (data.need_generation) {
      docs.push({ name: 'Draft SOTR', url: data.need_generation.draft_sotr });
      data.need_generation.need_files?.forEach((file: any, index: number) => {
        docs.push({ name: `Need File ${index + 1}`, url: file.file });
      });
    }
    if (data.aip?.document) docs.push({ name: 'AIP Document', url: data.aip.document });
    if (data.qa_agecy?.nomination_file?.length > 0) {
      data.qa_agecy.nomination_file.forEach((file: any, index: number) => {
        docs.push({ name: `QA Agency File ${index + 1}`, url: file.file });
      });
    }
    if (data.aon_soc) {
      if (data.aon_soc.aon) docs.push({ name: 'AON', url: data.aon_soc.aon });
      if (data.aon_soc.soc) docs.push({ name: 'SOC', url: data.aon_soc.soc });
    }
    if (data.pre_rfp_meeting?.mom) docs.push({ name: 'Pre-RFP Meeting MoM', url: data.pre_rfp_meeting.mom });
    if (data.pre_eoi_meeting?.file) docs.push({ name: 'Pre-EOI Meeting MoM', url: data.pre_eoi_meeting.file });
    if (data.pre_bid_meeting?.mom) docs.push({ name: 'Pre-Bid Meeting MoM', url: data.pre_bid_meeting.mom });
    if (data.final_offer?.offer) docs.push({ name: 'Final Offer', url: data.final_offer.offer });
    if (data.drawings_documents) {
      if (data.drawings_documents.drawing) docs.push({ name: 'Drawing File', url: data.drawings_documents.drawing });
      if (data.drawings_documents.document) docs.push({ name: 'Document File (Drawings)', url: data.drawings_documents.document });
    }
    if (data.qap_atp) {
      if (data.qap_atp.qap) docs.push({ name: 'QAP File', url: data.qap_atp.qap });
      if (data.qap_atp.document) docs.push({ name: 'ATP Document', url: data.qap_atp.document });
    }
    if (data.fats_prototype?.fat_report) docs.push({ name: 'FAT Report', url: data.fats_prototype.fat_report });
    if (data.user_certificate?.certificated) docs.push({ name: 'User Certificate', url: data.user_certificate.certificated });
    if (data.development_prototype?.file) docs.push({ name: 'Development Prototype', url: data.development_prototype.file });
    if (data.user_trials?.signed_documents) docs.push({ name: 'User Trials (Signed Docs)', url: data.user_trials.signed_documents });
    if (data.user_trials_make?.signed_documents) docs.push({ name: 'User Trials (Make)', url: data.user_trials_make.signed_documents });
    if (data.feasibility_study?.file) docs.push({ name: 'Feasibility Study', url: data.feasibility_study.file });
    if (data.bulk_production?.document) docs.push({ name: 'Bulk Production Document', url: data.bulk_production.document });
    return docs;
  }

  pdfconvert(htmlContent: string): void {
    if (!htmlContent) return;
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url; anchor.download = 'report.html'; anchor.click();
    window.URL.revokeObjectURL(url);
  }

  // submitIRA(): void {
  //   if (!this.step_details?.id) return;
  //   const payload = {
  //     proposal_step: this.step_details.id,
  //     approve_status: 1,
  //     remark: '',
  //     final_approval: this.confirmChecked ? 1 : 0
  //   };
  //   const sub = this.api.postAPI(`/transaction/copy/proposal-ira-action/`, payload).subscribe({
  //     next: (res: any) => this.messageService.add({
  //         severity: 'success', summary: 'Success', detail: res?.message || 'Proposal submitted successfully.'
  //       }),
  //     error: () => this.messageService.add({
  //         severity: 'error', summary: 'Error', detail: 'Unable to submit proposal IRA action.'
  //       })
  //   });
  //   this.subscriptions.add(sub);
  // }

  

  comment: string = '';
  submitIRA(): void {
    if (!this.step_details?.id) return;
    const payload = {
      editor_turn: this.step_details.editor_id,
      remarks: this.comment,
    };
    const sub = this.api.postAPI(`/file_mange/editor/approve/`, payload).subscribe(res=>{
      
      if(res.status !=='Approved') {

        this.transHeaderSteperComponent?.navigate(1,true);
      }else{
        this.transHeaderSteperComponent?.navigate(1,false,true);
      }
      }
    );
    this.subscriptions.add(sub);
  }

  generatePDF(event: any): void {
    this.pdfdata = event; this.displayDialog = true;
  }

  isHTMLorText(input: any): boolean {
    if (typeof input !== 'string') return false;
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  }

  saveVersion(): void {
    const data = document.getElementById('printSection')?.innerHTML;
    if (!data || !this.step_details?.id || !this.pdfdata?.url) {
      console.error('Missing required data for saving version.');
      return;
    }
    const payload = {
      proposal_step: this.step_details.id,
      name: this.DocName || 'Version',
      paragraph: data
    };
    const sub = this.api.postAPI(this.pdfdata.url, payload).subscribe({
      next: res => {
        this.DocName = '';
        this.messageService.add({
          severity: 'success', summary: 'Success', detail: res?.message || 'Version saved successfully.'
        });
      },
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to save version.'
      })
    });
    this.subscriptions.add(sub);
  }

  private fetchMasterData(): void {
    const sub = this.api.getAPI(`/master/master-data/`).subscribe({
      next: (res: any) => {
        const data = res?.data || [];
        this.masterData = data.map((item: any) => ({
          id: item.id,
          name: item.name,
          paragraph_1: item.paragraph_1,
          paragraph_2: item.paragraph_2,
          style: item.css_file_url,
          criteria_list: JSON.stringify(item.criteria_list, null, 2)
        }));
      },
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to fetch master data.'
      })
    });
    this.subscriptions.add(sub);
  }

  private fetchTabs(): void {
    if (!this.schemeId) return;
    const sub = this.api.getAPI(`/master/scheme/${this.schemeId}/phases/`).subscribe({
      next: (res: any) => (this.tabList = res || []),
      error: () => this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Unable to fetch phases.'
      })
    });
    this.subscriptions.add(sub);
  }
visibleConfirm: boolean = false;
 showConfirm(): void {
    this.messageService.clear('confirm');
    this.messageService.add({
      key: 'confirm',
      sticky: true,
      severity: 'info',
      summary: 'Are you sure you want to submit this proposal?'
    });
    this.visibleConfirm = true;
  }

  submitProposal(action: 1 | 2): void {
    this.needGen?.onSubmit();
    this.aip?.onSubmit();
    this.constituteCommitteeComponent?.onSubmit();
    this.feasibiltyStudyComponent?.onSubmit();
    this.makeIBenchmark?.submitProposalData();
    this.commercialEvaluation?.onSubmit();
    this.firmResponseSubmissionComponent?.onSubmit();
    this.rfiComponent?.onSubmit();
    this.rfpDetailsComponent?.onSubmit();
    this.draftSocComponent?.onSubmit();
    this.vcnsApprovalComponent?.onSubmit();
    this.receiptMomComponent?.onSubmit();
    this.vendorComponent?.onSubmit();
    this.psqrComponent?.onSubmit();
    
    this.aonComponent?.onSubmit();
    // this.pddComponent?.onSubmit();
    this.eoiComponent?.submitStep();
    this.preRfpMeetingComponent?.onSubmit();
    this.idexCommercialRfpComponent?.onRFPSubmit();
    this.technicalEveluationComponent?.onSubmit();
    this.makeITechnicalNegotiationsComponent?.onSubmit();
    this.commercialNegocatitionComponent?.onSubmit();
    this.finalOfferComponent?.onSubmit();
    this.sanctionOrderComponent?.onSubmit();
    this.idexPrototypeComponent?.onSubmitMake();
    this.idexUtrrComponent?.onJustificationSubmit();
    this.ssctComponent?.onSubmit();
    this.staffEvaluationComponent?.onSubmit();
    this.bulkProductionComponent?.onSubmit();
    this.preBidComponent?.onSubmit();
    this.evaluationOfEOI?.onSubmit();
    this.technicalNegotiation?.onSubmit();
    this.psqrToSqr?.onSubmit();
    this.uploadDrawingDocument?.onSubmit();
    this.messageService.clear('confirm');
    if (action === 2) this.submitIRA();
    this.visibleConfirm = false;
    this.transHeaderSteperComponent?.getWorkflowLogs();
  }

  checkIsNextRouteConfig() {
    const t = this.api.getData() || [];

  
    // current working directorate (top level)
    const currentIndex = t.findIndex(s => (s?.status ?? "") === "working");
    if (currentIndex === -1) return false;
  
    // 1) current directorate ke internalUsers me (current working user ke baad) koi edit hai kya?
    const curr = t[currentIndex];
    if (curr?.hasInternal && Array.isArray(curr.internalUsers) && curr.internalUsers.length) {
      const internalIndex = curr.internalUsers.findIndex(u => (u?.status ?? "") === "working");
  
      if (internalIndex !== -1) {
        const hasNextInternalEdit = curr.internalUsers
          .slice(internalIndex + 1)
          .some(u => (u?.permission ?? "") === "edit");
  
        if (hasNextInternalEdit) return true;
      } else {
        // Agar koi internal "working" marked hi nahi hai, still check any internal edit
        if (curr.internalUsers.some(u => (u?.permission ?? "") === "edit")) return true;
      }
    }
  
    // 2) currentIndex ke baad ke sabhi next directorates + unke internalUsers me koi edit hai kya?
    for (let i = currentIndex + 1; i < t.length; i++) {
      const next = t[i];
  
      // next directorate itself has edit
      if ((next?.permission ?? "") === "edit") return true;
  
      // next directorate ke kisi bhi internal user ke paas edit
      if (next?.hasInternal && Array.isArray(next.internalUsers) && next.internalUsers.length) {
        const anyInternalEdit = next.internalUsers.some(u => (u?.permission ?? "") === "edit");
        if (anyInternalEdit) return true;
      }
    }
  
    return false;
  }

  // trigarFromChild(): void {
  //   this.transHeaderSteperComponent?.openDialog();
  // }
  trigarFromChild(): void {
    this.messageService.clear('confirm');
    this.transHeaderSteperComponent?.openDialog();
    this.transHeaderSteperComponent?.giveTheRouteconfigAccess();
  }

  currentStepChange(event: any): void {
    this.step_details = event;
  }

  apiResponse: any;
  getReportData(): void {
    this.api.getAPI(`/make1/proposal/report/${this.proposalId}/`).subscribe((res) => {
      this.apiResponse = res;
    });
  }
}
